module.exports = __webpack_public_path__ + "static/media/greyed.61ff74bc.jpg";